import React from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import moment from 'moment'

const DetailsStockModal = ({dataRefOe, handleCopie, checkCopy}) => {
  return (
    <>
      <div className='modal fade' tabIndex={-1} id='modalDetailsStock'>
        <div className='modal-dialog' style={{maxWidth: '900px', width: '95%'}}>
          <div className='modal-content'>
            <div className='modal-header'>
              <div className="d-flex gap-2">
                <h5 className='modal-title'>
                  Liste des pièces en stock de la même ref OE : {dataRefOe[0]?.refConst}
                </h5>
                {dataRefOe[0]?.refConst &&
                    (checkCopy !== dataRefOe[0]?.refConst ? (
                        <i
                            className='ki-duotone ki-copy cursor-pointer fs-2'
                            onClick={(e) => handleCopie(dataRefOe[0]?.refConst, e)}
                        ></i>
                    ) : (
                        <i className='ki-duotone ki-copy-success fs-2'>
                          <span className='path1'></span>
                          <span className='path2'></span>
                        </i>
                    ))}
              </div>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                data-bs-target='#modal_details_cat'
                data-bs-toggle='modal'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body table-responsive'>
              {/* begin::Table */}
              <table className='table align-middle text-center table-row-dashed table-row-gray-300 gy-7'>
                {/* begin::Table head */}
                <thead>
                  <tr className='fw-bold text-muted'>
                    <th className='min-w-140px'>Code pièce</th>
                    <th className='min-w-140px'>Site</th>
                    <th className='min-w-140px'>Date de stockage</th>
                    <th className='min-w-140px'>Qualité</th>
                    <th className='min-w-140px'>Prix TTC</th>
                  </tr>
                </thead>
                {/* end::Table head */}
                {/* begin::Table body */}
                <tbody>
                  {dataRefOe.length ? (
                    dataRefOe.map((data) => {
                      return (
                        <tr key={data?.id}>
                          <td className="d-flex align-items-center justify-content-center gap-2">
                            <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                              {data?.codePiece}
                            </p>
                            {data?.codePiece &&
                                (checkCopy !== data?.codePiece ? (
                                    <i
                                        className='ki-duotone ki-copy cursor-pointer fs-2'
                                        onClick={(e) => handleCopie(data?.codePiece, e)}
                                    ></i>
                                ) : (
                                    <i className='ki-duotone ki-copy-success fs-2'>
                                      <span className='path1'></span>
                                      <span className='path2'></span>
                                    </i>
                                ))}
                          </td>
                          <td>
                            <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                              {data?.codeSite}
                            </p>
                          </td>
                          <td>
                            <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                              {data?.dateStockage &&
                                moment(data?.dateStockage).format('DD/MM/YYYY')}
                            </p>
                          </td>
                          <td>
                            <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                              {data?.etatLibelle}
                            </p>
                          </td>
                          <td>
                            <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                              {data?.idModifPrix ? data?.nouveauPrix.toFixed(
                                  2
                              ) : (
                                data?.prixHT != null && data?.tauxTva != null
                                ? (Number(data.prixHT) * (1 + Number(data.tauxTva) / 100)).toFixed(
                                    2
                                  )
                                : '')
                              }{' '}
                            </p>
                          </td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr className='min-w-140px'>
                      <td colSpan={5} className='text-center'>
                        Aucun résultat trouvé
                      </td>
                    </tr>
                  )}
                </tbody>
                {/* end::Table body */}
              </table>
              {/* end::Table */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export {DetailsStockModal}
